/**
 * Generate a URL-safe random ID. Uses crypto.randomUUID when available
 * (works in Cloudflare Workers, Node 18+, and browsers).
 */
export function newId(prefix?: string): string {
  const id = crypto.randomUUID().replace(/-/g, '');
  return prefix ? `${prefix}_${id}` : id;
}
